import { FlatProject } from '../../domain/project/FlatProject';
import { FlatProjectDTO } from '../../domain/project/FlatProjectDTO';

export class FlatProjectMapper {
  static toDomain(props: FlatProjectDTO): FlatProject {
    const { id, label, avatar_url, description, users } = props;

    return FlatProject.create(
      {
        label,
        avatar_url,
        description,
        users,
      },
      id
    );
  }
}
